import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import _ from "lodash";

import infoIcon from "../../images/infoIcon.svg"
import Congrats from "../../images/congrats.png";
import { AiTwotoneMail } from 'react-icons/ai'

import {
    TOTAL_GITHUB_USERS,
    TOTAL_STACKOVERFLOW_USERS,
  } from "../../utils/totalNumberUsers";
  
  import {
    DISPLAY_STRING_GH,
    DISPLAY_STRING_SO,
  } from "../../utils/serviceName";

const RankingTooltipGH = () => {
    return <span className="tooltip">
      <img src={infoIcon} alt="info-icon" />
      <p className="tooltiptext">
        {DISPLAY_STRING_GH} is where over {TOTAL_GITHUB_USERS} pesudo anonymous million developers contribute to the open source community &amp; manage their code repositories
      </p>
     </span>
    };
  
    
const RankingTooltipSO = () => {
    return <span className="tooltip">
    <img src={infoIcon} alt="info-icon" />
    <p className="tooltiptext">
        {DISPLAY_STRING_SO} is the largest pseudo anonymous community for {TOTAL_STACKOVERFLOW_USERS} million developers to learn &amp; share​ ​their programming ​knowledge
    </p>
    </span>
};

// Return if we could introduce the techi to the recruiter
const Contact_us_about_techi = (github,username,retrieved_github_user_email, expectedLevelAndResGH) => {
  const href_content = `mailto:introductions@techierank.com?subject=Please facilitate an introduction to GitHub user ${username}&body=I would like an introduction to GitHub user ${username} because ...`;

  if (retrieved_github_user_email === true && github === true) {
    return <span className="congrats email_congrats" style={{padding: expectedLevelAndResGH === true ? "0 20px 0 20px": "0 20px 2rem 20px"}}>
      <AiTwotoneMail />&nbsp;We maybe able to facilitate an introduction to this Techie - please&nbsp;<a href={href_content} target="_blank" rel="noopener noreferrer">let us know why you'd like to be introduced</a>?
      <br/><p style={{color: "white"}}>(subscribers can contact Techies directly)</p>
    </span>
  } else {
    return <></>
  }
}

// Return the congrats message
const Congrats_Msg = (github, expectedLevelGH, expectedLevelSO) => {
  return <>
    <div className="congrats">
      <img src={Congrats} alt="Congrats" />&nbsp;Congratulations you may have found a diamond in the rough!
    </div> 
      {github === true ? <p className="candidate__info">Your Techie is above the typical top {expectedLevelGH === "intern" ? "100-80%" : expectedLevelGH === "junior" ? "80-60%" : expectedLevelGH === "mid-level" ? '60-40%' : '40-20%'} range for {expectedLevelGH} level developers.<br/><br/></p> : 
      <p className="candidate__info">Your Techie is above the typical top {expectedLevelSO === "intern" ? "100-80%" : expectedLevelSO === "junior" ? "80-60%" : expectedLevelSO === "mid-level" ? '60-40%' : '40-0%'} range for {expectedLevelSO} level developers.<br/><br/></p>}
      {/* {Contact_us_about_techi(github)} */}
  </>
}

  // Return Not enough data message
  const NotEnoughData_Msg = (github,username,retrieved_github_user_email, expectedLevelAndResGH) => {
    return <>
      <div className="non-congrats">
        <p>Not enough data to tell if this Techie may be a diamond in the rough or not.</p>
      </div>
      {Contact_us_about_techi(github,username,retrieved_github_user_email, expectedLevelAndResGH)}
    </>
  }

// Get the number of people user is higher than
const higher_than = (ranking, total) => {
let int_ranking = parseInt(ranking)
return total - parseInt((total*int_ranking)/100)
}

const parseTopByInToHighMediumLow = (topString) => {
const topPercentage = Math.min(100, parseInt(topString.replace('top ', '').split('.')[0]));
return topPercentage >= 66 ? 'low' : topPercentage >= 33 ? 'medium' : 'high';
};

const RankingGHOrSO = ({rankingAndOwnRatingAndGHElseSO, result, resultStackOverflow, gHAdditionalRankingData, username, expectedLevelAndResGH, expectedLevelGH, expectedLevelSO}) => {
    var resu = 0
    const NOT_TOP_50 = "not_top_50";

    if(rankingAndOwnRatingAndGHElseSO[2] === true && result !== 'not_top_50'){
      resu = higher_than(result, TOTAL_GITHUB_USERS)
    }else if(rankingAndOwnRatingAndGHElseSO[2] === false && resultStackOverflow !== 'not_top_50'){
      resu = higher_than(resultStackOverflow, TOTAL_STACKOVERFLOW_USERS)
    }

    const ghAccountAge = gHAdditionalRankingData?.since ? ' (' + gHAdditionalRankingData.since.split(' ')[0].replace('+', '') + ' months)' : false;
    const ghTopByRepos = gHAdditionalRankingData?.user_byrepos ? parseTopByInToHighMediumLow(gHAdditionalRankingData.user_byrepos) + ' ' : false;
    const ghTopByStars = gHAdditionalRankingData?.toprepo_bystars ? parseTopByInToHighMediumLow(gHAdditionalRankingData.toprepo_bystars) + ' number of ' : false;
    const ghTopByFollowers = gHAdditionalRankingData?.user_byfollowers ? 'a ' + parseTopByInToHighMediumLow(gHAdditionalRankingData.user_byfollowers) + ' ' : false;

    return <>
      { rankingAndOwnRatingAndGHElseSO[0] === NOT_TOP_50 ? (
        <span>
          <h2>Profile ownership verified!</h2>
          { rankingAndOwnRatingAndGHElseSO[2] ? <RankingTooltipGH/> : <RankingTooltipSO/> }
        </span>
        ) : (
          <>
            <p className="p1 p1_top_part">
              {rankingAndOwnRatingAndGHElseSO[1] ? "Congratulations! You are r" : "R"}ankedin the
            </p>
            <span>
              <h2>Top {rankingAndOwnRatingAndGHElseSO[0]}% of { rankingAndOwnRatingAndGHElseSO[2] ? TOTAL_GITHUB_USERS : TOTAL_STACKOVERFLOW_USERS } million { rankingAndOwnRatingAndGHElseSO[2] ? DISPLAY_STRING_GH : DISPLAY_STRING_SO } users</h2>
              { rankingAndOwnRatingAndGHElseSO[2] ? <RankingTooltipGH/> : <RankingTooltipSO/> }
            </span>
          </>
        )}
        <p className="p1">
          {rankingAndOwnRatingAndGHElseSO[0] === NOT_TOP_50 ? `You are not in the top 50%... yet!` : resu !== 0 && `(so above about ${resu} million developers)`}
        </p>

        { // TODO use this GH ranking message format everywhere not just employer's dashboard

          rankingAndOwnRatingAndGHElseSO[2] === true ? <span className="tooltip">
            <p className="tooltiptext tooltiptext_ranking" >
              <br/>
              Ranking is based on {username}'s account age{ghAccountAge ? ghAccountAge : ''}, {ghTopByRepos ? ghTopByRepos : ''}number of contributions to code repositories, {ghTopByStars ? ghTopByStars : ''}repository stars (showing quality of projects) and {ghTopByFollowers ? ghTopByFollowers : ''}following.
            </p>
          </span> :
          <span className="tooltip">
            <p className="tooltiptext tooltiptext_ranking">
              <br/>
              Ranking is based on reputation on {DISPLAY_STRING_SO} determined by community votes on quality questions, answers and comments.
            </p>
          </span>
        }

        {
        rankingAndOwnRatingAndGHElseSO[3] === true && Congrats_Msg(rankingAndOwnRatingAndGHElseSO[2] === true, username, expectedLevelGH, expectedLevelSO)
        }

        {(
          rankingAndOwnRatingAndGHElseSO[2] === true && expectedLevelAndResGH === true) && Contact_us_about_techi(true)
        }

        { rankingAndOwnRatingAndGHElseSO[1] ? (
        <>
          <br/>
          <p className="p1-job-hunting"><span>Job Hunting?</span><br/> { rankingAndOwnRatingAndGHElseSO[2] ? 
          <>Recruiters & employers check {DISPLAY_STRING_GH} and like to see your progress. <br />Stand out from your peers in the 6 seconds your application is reviewed by {rankingAndOwnRatingAndGHElseSO[0] === NOT_TOP_50 
            ? `uploading your own projects (and setting your private activity public) or contributing to open source projects and share proof of your ${DISPLAY_STRING_GH} ownership`
            : `sharing your proof of rank`} on your CV or on LinkedIn via our free Verifiable Credential!</>
          : <>Recruiters & employers tell us that contributing on {DISPLAY_STRING_SO} makes you stand out from your peers in the 6 seconds your application is reviewed. <br />{rankingAndOwnRatingAndGHElseSO[0] === NOT_TOP_50
            ? `Try to ask good questions or answer or comment on others' questions and share proof of your ${DISPLAY_STRING_SO} ownership` 
            : `Share your proof of rank`} on your CV or on LinkedIn via our free Verifiable Credential!</>
          }
          </p>
          <br/>
        </>) : (null) }
      </>
  };

export default RankingGHOrSO
export {NotEnoughData_Msg}